import { render, staticRenderFns } from "./form-bonus.vue?vue&type=template&id=1b9b0cf0&"
import script from "./form-bonus.vue?vue&type=script&lang=js&"
export * from "./form-bonus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports